import React, { useState, useEffect, useRef, useContext } from "react";
import ReactMapboxGl, { Marker } from "react-mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import Logo from "../../assets/images/logo.png";
import fire from "../../assets/images/fire.png";
import { FaLocationArrow } from "react-icons/fa";
import { getGoogleLocation } from "../../utils/utils";
import { MapContext } from "../../context/MapContext";
import { accessToken } from "../../config";
import mapboxgl from "mapbox-gl";
import "./mapbox.css";

const Map = ReactMapboxGl({
  accessToken: accessToken,
  logoPosition: "bottom-right",
});

const MapBox = ({ mapEvents, handleSinglePost }) => {
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [activeMarkerId, setActiveMarkerId] = useState(null);
  const [centeredMarkerId, setCenteredMarkerId] = useState(null);
  const localMapRef = useRef(null);
  const { setMapRef } = useContext(MapContext);

  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const { lat, lng } = await getGoogleLocation();
        setLatitude(lat);
        setLongitude(lng);
      } catch (error) {
        console.error("Error fetching location:", error);
      }
    };
    fetchLocation();
  }, []);

  useEffect(() => {
    if (localMapRef.current) {
      setMapRef({ current: localMapRef.current });
    }
  }, [localMapRef.current]);

  const handleRecenterMap = () => {
    if (localMapRef.current && latitude && longitude) {
      setActiveMarkerId(null);
      setCenteredMarkerId(null);
      localMapRef.current.flyTo({
        center: [longitude, latitude],
        zoom: 15,
        speed: 1.2,
      });
    }
  };


  return (
    <>
      {longitude && latitude && (
        <div className="relative w-full h-screen" id="container">
          <Map
            ref={(map) => {
              if (map && map.getMap) {
                localMapRef.current = map.getMap();
              }
            }}
            onStyleLoad={(map) => {
              localMapRef.current = map;
            }}
            renderChildrenInPortal={true}
            // eslint-disable-next-line react/style-prop-object
            style="mapbox://styles/mapbox/streets-v8?optimize=true"
            center={[longitude, latitude]}
            zoom={[15]}
            movingMethod="easeTo"
            containerStyle={{
              height: "100vh",
              width: "100%",
            }}
            className="w-full"
          >
            <Marker coordinates={[longitude, latitude]} className={"flex justify-center items-center"}>
              <img
                src={"/user-location.png"}
                alt="user-location"
              />
            </Marker>

            {/* Render event markers */}
            {mapEvents?.map((item, index) => {
              const markerId = item.id || `index-${index}`;
              const isActive =
                markerId === activeMarkerId ||
                (markerId === centeredMarkerId && !activeMarkerId);

              return (
                <Marker
                  key={markerId}
                  coordinates={[item.coords.longitude, item.coords.latitude]}
                >
                  <div
                    className={`w-9 h-9 rounded-full bg-white p-1 flex items-center justify-center border-2 border-red-500 hover:cursor-pointer transition-all duration-300 ${item.category.title === "Safety & Emergencies" ||
                        item.category.title === "Crime & Safety Reports"
                        ? "marker-glow"
                        : ""
                      } ${isActive ? "marker-glow" : "hover:marker-glow"}`}
                    onClick={() => {
                      setActiveMarkerId(markerId);
                      setCenteredMarkerId(null);
                      setTimeout(() => {
                        if (handleSinglePost) {
                          handleSinglePost(item);
                        }
                      }, 300);
                    }}
                  >
                    <img
                      src={
                        item.category.title === "Safety & Emergencies" ||
                          item.category.title === "Crime & Safety Reports"
                          ? fire
                          : Logo
                      }
                      alt="marker-icon"
                      className="rounded-full object-contain w-5 h-5"
                    />
                  </div>
                </Marker>
              );
            })}
          </Map>
          <button
            onClick={handleRecenterMap}
            className="absolute bottom-10 left-4 bg-white p-3 rounded-full shadow-md hover:bg-gray-100 z-10 flex items-center gap-2"
            aria-label="Recenter map"
          >
            <FaLocationArrow className="text-blue-500" />
            <span>Re-center</span>
          </button>
        </div>
      )}
    </>
  );
};

export default MapBox;